"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HandDeltaReason = exports.CardSuit = exports.TableState = exports.HandAction = exports.PokerRound = exports.StorageSuccess = exports.GamePayloadType = void 0;
var GamePayloadType;
(function (GamePayloadType) {
    GamePayloadType["EXE"] = "EXE";
    GamePayloadType["APK"] = "APK";
    GamePayloadType["IPA"] = "IPA";
    GamePayloadType["APP"] = "APP";
})(GamePayloadType = exports.GamePayloadType || (exports.GamePayloadType = {}));
var StorageSuccess;
(function (StorageSuccess) {
    StorageSuccess["Complete"] = "Complete";
    StorageSuccess["Partial"] = "Partial";
    StorageSuccess["Rejected"] = "Rejected";
})(StorageSuccess = exports.StorageSuccess || (exports.StorageSuccess = {}));
var PokerRound;
(function (PokerRound) {
    PokerRound["Flop"] = "Flop";
    PokerRound["Preflop"] = "Preflop";
    PokerRound["River"] = "River";
    PokerRound["Showdown"] = "Showdown";
    PokerRound["Turn"] = "Turn";
})(PokerRound = exports.PokerRound || (exports.PokerRound = {}));
var HandAction;
(function (HandAction) {
    HandAction["Bet"] = "Bet";
    HandAction["Call"] = "Call";
    HandAction["Check"] = "Check";
    HandAction["Fold"] = "Fold";
    HandAction["Raise"] = "Raise";
})(HandAction = exports.HandAction || (exports.HandAction = {}));
var TableState;
(function (TableState) {
    TableState["FLOP"] = "Flop";
    TableState["PREFLOP"] = "Preflop";
    TableState["RIVER"] = "River";
    TableState["SHOWDOWN"] = "Showdown";
    TableState["TURN"] = "Turn";
    TableState["COMPLETE"] = "Complete";
})(TableState = exports.TableState || (exports.TableState = {}));
var CardSuit;
(function (CardSuit) {
    CardSuit["DIAMONDS"] = "Diamonds";
    CardSuit["HEARTS"] = "Hearts";
    CardSuit["CLUBS"] = "Clubs";
    CardSuit["SPADES"] = "Spades";
})(CardSuit = exports.CardSuit || (exports.CardSuit = {}));
var HandDeltaReason;
(function (HandDeltaReason) {
    HandDeltaReason["Leave"] = "Leave";
    HandDeltaReason["Loss"] = "Loss";
    HandDeltaReason["Tie"] = "Tie";
    HandDeltaReason["Win"] = "Win";
})(HandDeltaReason = exports.HandDeltaReason || (exports.HandDeltaReason = {}));
